import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Process, ProcessesSliceState } from "./processes-interface";
import {
  fetchAllProcesses,
  fetchProcessByUuid,
  fetchProcesses,
} from "./processes-async-calls";

const initialState: ProcessesSliceState = {
  processes: [],
  isFetching: false,
  selectedProcess: undefined,
};

const processesSlice = createSlice({
  name: "processes",
  initialState,
  reducers: {
    setSelectedProcess: (state, action: PayloadAction<Process | undefined>) => {
      state.selectedProcess = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcesses.pending, (state) => {
        state.processes = [];
        state.isFetching = true;
      })
      .addCase(fetchProcesses.fulfilled, (state, action) => {
        state.processes = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchProcesses.rejected, (state) => {
        state.processes = [];
        state.isFetching = false;
      })
      .addCase(fetchProcessByUuid.pending, (state) => {
        state.selectedProcess = undefined;
        state.isFetching = true;
      })
      .addCase(fetchProcessByUuid.fulfilled, (state, action) => {
        state.selectedProcess = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchProcessByUuid.rejected, (state) => {
        state.selectedProcess = undefined;
        state.isFetching = false;
      })
      .addCase(fetchAllProcesses.pending, (state) => {
        state.processes = [];
        state.isFetching = true;
      })
      .addCase(fetchAllProcesses.fulfilled, (state, action) => {
        state.processes = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchAllProcesses.rejected, (state) => {
        state.processes = [];
        state.isFetching = false;
      });
  },
});

export const { setSelectedProcess } = processesSlice.actions;

export default processesSlice.reducer;
